import { connect }     from 'react-redux';
import Locale      from '../../../locale';
import Errors      from '../../../errors';
import { routeTo } from '../../../routing-dux';
import {
    dismissError,
    dismissAllErrors } from '../../../errors-dux';
import {
    activate,
    preActivationLoginAttempt } from './activation-dux';

import Activation from './activation.jsx';

export default connect(
    // mapStateToProps
    state => ( {
        passwordRules: state.clientData.passwordRules,
        preActivationLoginAttemptFlag: state.activationData.preActivationLoginAttemptFlag,
        warningMessage: state.activationData.warningMessage,
        errors: Errors.getByType( state, Errors.ERROR_ACTIVATION_ACTIVATE ),
        activating: state.activationData.busy,
        activationFields: state.clientData.clientBranding.activationFields,
        hireDatePlaceholder: Locale.getString( state, 'activation.form.hireDatePlaceholder' ),
        birthDatePlaceholder: Locale.getString( state, 'activation.form.birthDatePlaceholder' ),
        locale: state.userData.locale,
        done: state.userData.authenticated,
        passwordRequirements: Locale.getString( state, 'common.passwordRules.requirementsLabel' ),
        passwordLabels: {
            isLowerCaseRequired: Locale.getString( state, 'common.passwordRules.lowercaseLabel' ),
            isUpperCaseRequired: Locale.getString( state, 'common.passwordRules.uppercaseLabel' ),
            isSpecialCharRequired: Locale.getString( state, 'common.passwordRules.specialCharacterLabel' ),
            isNumberRequired: Locale.getString( state, 'common.passwordRules.numberLabel' ),
            length: Locale.getString( state, 'common.passwordRules.lengthLabel', {
                minLength: state.clientData.passwordRules.minLength,
                maxLength: state.clientData.passwordRules.maxLength
            } )
        }
    } ),
    // mapDispatchToProps
    {
        activate,
        dismissError,
        dismissAllErrors,
        preActivationLoginAttempt,
        routeTo
    }
)( Activation );
